/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import { connect } from 'react-redux';
// import Toast from './sub_components/toast';
import * as authServices from '../services/authService';
import * as accountServices from '../services/accountService'
// import * as utilService from '../services/utilService'
// import Joinnowpopup from './sub_components/joinnowpopup'
// import Loginpopup from './sub_components/loginpopup'
import LoginSportsThumbnailList from './sub_components/loginSportsThumbnailList'
import AboutUs from './sub_components/aboutUs'
import BettingRules from './sub_components/bettingRules'
import DepositsAndWithdrawals from './sub_components/depositsAndWithdrawals'
import PrivacyPolicy from './sub_components/privacyPolicy'
import TermsAndConditions from './sub_components/termsAndConditions'
// import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { staticContentsImagePath as BASE_IMAGE_PATH, OPERATOR_ID } from '../configs/const';
import { DOMAINDISPLAY } from '../configs/apkFileName';
// import { ReCAPTCHA_KEY } from '../configs/const';
// import ReCAPTCHA from "react-google-recaptcha";
// import Maintanence from './sub_components/maintanence'
// import * as constants from '../configs/const'
import Loginb2cHeader from './loginb2cHeader';
// import bannerList from 'https://images.staticcontents.com/banners/list.json'

import { APK_FILE_NAME, SOCIALMEDIALINKS } from '../configs/apkFileName';
import { LBLTYPE } from '../configs/casinoShowList';
import { DMN, DMNNM } from '../configs/ops';

let oid = OPERATOR_ID.toLowerCase()
// const recaptchaRef = React.createRef();
const hostname = window && window.location && window.location.hostname;

class Loginb2cFooter extends Component {
    constructor(props) {
        super(props);
        this.state = {
            clientWidth: document.documentElement.clientWidth,
        };
    }

    formatPickerDate(date) {
        var d = date,
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2)
            month = '0' + month;
        if (day.length < 2)
            day = '0' + day;
        year = year.toString().slice(-2)
        return [year, month, day].join('');
    }

    async componentDidMount() {

    }

    toggleSelectedSection(name) {
        debugger
        // if(window.location.pathname !== '/auth' && !window.location.pathname.includes('/auth/') && window.location.pathname !== '/'){
        //     this.props.history.push(`/auth/${name}`)
        // } else {
        //     this.props.toggleSelectedSection(name);
        // }
    }
    render() {
        const accData = JSON.parse(localStorage.getItem("accountData"));
        let SclMd = localStorage.getItem("SocialMedia");
        if(!!SclMd && Object.keys(SclMd).length > 0){
            SclMd = JSON.parse(SclMd);
        }
        return (
            <>

                {/* END NEW LOGIN B2C */}
                {!(!!accData && Object.keys(accData).length > 0) && <div className="partner_logo">
                    <ul className='footer-providers__list footer-icon-desktop'>
                        <li className='footer-providers__list-item'>
                            <a className="footer-providers__list-item-link" href="#">
                                <img src={BASE_IMAGE_PATH + "/casino/banner/loginimages/evolution.png"} alt="Evolution" />
                            </a>
                        </li>
                        <li className='footer-providers__list-item'>
                            <a className="footer-providers__list-item-link" href="#">
                                <img src={BASE_IMAGE_PATH + "/casino/banner/loginimages/ezugi.png"} alt="Ezugi" />
                            </a>
                        </li>
                        <li className='footer-providers__list-item'>
                            <a className="footer-providers__list-item-link" href="#">
                                <img src={BASE_IMAGE_PATH + "/casino/banner/loginimages/pragmatic-live.png"} alt="Pragmatic Live" />
                            </a>
                        </li>
                        <li className='footer-providers__list-item'>
                            <a className="footer-providers__list-item-link" href="#">
                                <img src={BASE_IMAGE_PATH + "/casino/banner/loginimages/betgames.png"} alt="Betgames" />
                            </a>
                        </li>
                        <li className='footer-providers__list-item'>
                            <a className="footer-providers__list-item-link" href="#">
                                <img src={BASE_IMAGE_PATH + "/casino/banner/loginimages/ssg.png"} alt="Super Spade Games" />
                            </a>
                        </li>
                        <li className='footer-providers__list-item'>
                            <a className="footer-providers__list-item-link" href="#">
                                <img src={BASE_IMAGE_PATH + "/casino/banner/loginimages/betsoft.png"} alt="Betsoft" />
                            </a>
                        </li>
                        <li className='footer-providers__list-item'>
                            <a className="footer-providers__list-item-link" href="#">
                                <img src={BASE_IMAGE_PATH + "/casino/banner/loginimages/spribe.png"} alt="Spribe" />
                            </a>
                        </li>
                        <li className='footer-providers__list-item'>
                            <a className="footer-providers__list-item-link" href="#">
                                <img src={BASE_IMAGE_PATH + "/casino/banner/loginimages/Evoplay.png"} alt="Evoplay" />
                            </a>
                        </li>
                        <li className='footer-providers__list-item lastli'>
                            <a className="footer-providers__list-item-link" href="#">
                                <img src={BASE_IMAGE_PATH + "/casino/banner/loginimages/logo-18plus.svg"} alt="+18" />
                            </a>
                        </li>
                    </ul>

                    <ul className='footer-providers__list footer-icon-mobile'>
                        <li className='footer-providers__list-item'>
                            <a className="footer-providers__list-item-link" href="#">
                                <img src={BASE_IMAGE_PATH + "/casino/banner/loginimages/mobile/evolution.svg"} alt="Evolution" />
                            </a>
                        </li>
                        <li className='footer-providers__list-item'>
                            <a className="footer-providers__list-item-link" href="#">
                                <img src={BASE_IMAGE_PATH + "/casino/banner/loginimages/mobile/ezugi.svg"} alt="Ezugi" />
                            </a>
                        </li>
                        <li className='footer-providers__list-item'>
                            <a className="footer-providers__list-item-link" href="#">
                                <img src={BASE_IMAGE_PATH + "/casino/banner/loginimages/mobile/pragmatic.svg"} alt="Pragmatic Live" />
                            </a>
                        </li>
                        <li className='footer-providers__list-item'>
                            <a className="footer-providers__list-item-link" href="#">
                                <img src={BASE_IMAGE_PATH + "/casino/banner/loginimages/mobile/betgames.svg"} alt="Betgames" />
                            </a>
                        </li>
                        <li className='footer-providers__list-item'>
                            <a className="footer-providers__list-item-link" href="#">
                                <img src={BASE_IMAGE_PATH + "/casino/banner/loginimages/mobile/superspade.svg"} alt="Super Spade Games" />
                            </a>
                        </li>
                        <li className='footer-providers__list-item'>
                            <a className="footer-providers__list-item-link" href="#">
                                <img src={BASE_IMAGE_PATH + "/casino/banner/loginimages/mobile/betsoft.svg"} alt="Betsoft" />
                            </a>
                        </li>
                        <li className='footer-providers__list-item'>
                            <a className="footer-providers__list-item-link" href="#">
                                <img src={BASE_IMAGE_PATH + "/casino/banner/loginimages/mobile/spribe.svg"} alt="Spribe" />
                            </a>
                        </li>
                        <li className='footer-providers__list-item'>
                            <a className="footer-providers__list-item-link" href="#">
                                <img src={BASE_IMAGE_PATH + "/casino/banner/loginimages/mobile/evoplay.svg"} alt="Evoplay" />
                            </a>
                        </li>
                        <li className='footer-providers__list-item lastli'>
                            <a className="footer-providers__list-item-link" href="#">
                                <img src={BASE_IMAGE_PATH + "/casino/banner/loginimages/mobile/logo-18plus.svg"} alt="+18" />
                            </a>
                        </li>
                    </ul>
                    {LBLTYPE === 'b2c' &&
                        <div className='container ft-footer-widget-wrapper-2'>
                            <div className='row'>
                                <div className='col-sm-3 col-md-3 col-6'>
                                    <div className="ft-footer-widget ul-li-block headline pera-content">
                                        <div className="logo-widget">
                                            <div className="site-logo footerlogodesktop">
                                                <a href="#"><img src={BASE_IMAGE_PATH + "/" + oid + "/uimg/brand_logo_footer.svg"} width="195" height="60px" /></a>
                                            </div>
                                            <div className="footerlogomobile">
                                                <a href="#"><img src={BASE_IMAGE_PATH + "/" + oid + "/uimg/brand_logo_footer1.svg"} width="195" height="60px" /></a>
                                            </div>
                                            <div className="ft-footer-address">
                                                {/* <span className='font-bold mb-0'>Official Sponsor of</span>
                                                <div className='apl-log'><img src={BASE_IMAGE_PATH + "/" + oid + "/uimg/apl-logo.png"} /></div>
                                                <span>Address: 27 Division St, New York, NY 10002, USA</span> */}
                                                <span>Website: www.{DOMAINDISPLAY.name}.{DOMAINDISPLAY.domain}</span>
                                                <span>Email: support@{DOMAINDISPLAY.name}.{DOMAINDISPLAY.domain}</span>
                                                <span className='whats-app-color'>Whatsapp: <a href={(!!SclMd && (SclMd?.SOCIALMEDIALINKS?.whatsapp?.includes(',') ? SclMd?.SOCIALMEDIALINKS?.whatsapp?.split(',')[0] : SclMd?.SOCIALMEDIALINKS?.whatsapp))}>{!!SclMd && (SclMd?.SOCIALMEDIALINKS?.whatsappDisplayNumber?.includes(',') ? SclMd?.SOCIALMEDIALINKS?.whatsappDisplayNumber?.split(',')[0] : SclMd?.SOCIALMEDIALINKS?.whatsappDisplayNumber)}</a></span>
                                                {/* <span>Phone: +8 (123) 152 25 45</span> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-3 col-md-3 col-6">
                                    <div className="ft-footer-widget ul-li-block headline pera-content">
                                        <div className="menu-widget">
                                            <h3 className="widget-title">{DOMAINDISPLAY.name}</h3>
                                            <ul>
                                                <li><a href="#">Blog {DOMAINDISPLAY.name}</a></li>
                                                <li><a href='#' className={this.props.selectedSection === "aboutus" ? 'active' : ''}>About Us</a></li>
                                                <li><a href='#' className={this.props.selectedSection === "responsiblegaming" ? 'active' : ''}>Responsible Gaming</a></li>
                                                <li><a href={`https://aff.${DMNNM}.${DMN}/`}>{DOMAINDISPLAY.name} Affiliates</a></li>
                                                <li><a href='#' className={this.props.selectedSection === "contactus" ? 'active' : ''}>Contact Us</a></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-3 col-md-3 col-6">
                                    <div className="ft-footer-widget ul-li-block headline pera-content">
                                        <div className="menu-widget">
                                            <h3 className="widget-title">Usage and Terms</h3>
                                            <ul>
                                                <li><a href='#' className={this.props.selectedSection === "termandconditions" ? 'active' : ''}>Terms and Conditions</a></li>
                                                <li><a href='#' className={this.props.selectedSection === "privacypolicy" ? 'active' : ''}>Privacy Policy</a></li>
                                                <li><a href='#' className={this.props.selectedSection === "bettingrules" ? 'active' : ''}>Betting Rules</a></li>
                                                <li><a href='#' className={this.props.selectedSection === "howtoplay" ? 'active' : ''}>How to Play</a></li>
                                                <li><a href='#' className={this.props.selectedSection === "rulesregulations" ? 'active' : ''}>Rules Regulations</a></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-3 col-md-3 col-6">
                                    <div className="ft-footer-widget ul-li-block headline pera-content">
                                        <div className="menu-widget">
                                            <h3 className="widget-title">Quick Links</h3>
                                            <ul>
                                                <li>
                                                    <a href='#' alt="Make a call" rel="noreferrer" data-toggle="tooltip" data-placement="bottom" title="Have Question?" className={window.location.pathname === "/faq" ? "active" : ""}>FAQ</a></li>
                                                <li><a href="#">Make a Call</a></li>
                                                <li><a href="#" onClick={() => { window.location.href = `https://apk.staticcontent.io/${APK_FILE_NAME}.apk` }}>Download APK</a></li>
                                                <li><a href='#' className={this.props.selectedSection === "depositsandwithdrawals" ? 'active' : ''}>Deposits and Withdrawals Rules</a></li>
                                                <li><a href='#' className={this.props.selectedSection === "cookiepolicy" ? 'active' : ''}>Cookie Policy</a></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                    <div className='rules'>You must be over 18 years old, or the legal age at which gambling or gaming activities are allowed under the law or jurisdiction that applies to you.
                        You must reside in a country in which access to online gambling to its residents.</div>
                    <div className='d-none'>
                        <ul className='bettingrules'>
                            <li><a href='#' className={this.props.selectedSection === "" ? 'active' : ''}>Home</a></li>
                            <li><a href='#' className={this.props.selectedSection === "aboutus" ? 'active' : ''}>About Us</a></li>
                            <li><a href='#' className={this.props.selectedSection === "termandconditions" ? 'active' : ''}>Terms and Conditions</a></li>
                            <li><a href='#' className={this.props.selectedSection === "privacypolicy" ? 'active' : ''}>Privacy Policy</a></li>
                            <li><a href='#' className={this.props.selectedSection === "bettingrules" ? 'active' : ''}>Betting Rules</a></li>
                            <li><a href='#' className={this.props.selectedSection === "depositsandwithdrawals" ? 'active' : ''}>Deposits and Withdrawals Rules</a></li>
                        </ul>
                    </div>

                </div>
                }


            </>)
    }
}

function mapStateToProps(state) {
    return {
    };
}

function mapDispatchToProps(dispatch) {
    return {
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(Loginb2cFooter);